import React from 'react';
import './Upcoming1.css';
import Navbar2 from '../../Navbar/Navbar2/Navbar2';
import Footer from '../../Footer/Footer';
import { FaCogs, FaTimesCircle, FaBalanceScale, FaTemperatureHigh, FaShip, FaTachometerAlt, FaMicrochip, FaExclamationTriangle, FaChartLine, FaTools, FaNetworkWired, FaBrain, FaCheckCircle, FaListAlt, FaCog, FaServer, FaShieldAlt, FaExternalLinkAlt, FaEye } from 'react-icons/fa';
import { GiFuelTank } from 'react-icons/gi';


const Upcoming1 = ({ onNavigate }) => {
  return (          
    <>
    <Navbar2 onNavigate={onNavigate} />
    <section className="thrustpower-hero">
      {/* <div className="thrustpower-container">
        <h1 className="thrustpower-title">Shipshape ThrustPower™</h1>
        <p className="thrustpower-subtitle">
          Lightweight System to Measure Torque, Power, and Thrust—In Real Time
        </p>
        <p className="thrustpower-description">
          A patent-pending, lightweight shaftline performance system that delivers accurate, real-time
          measurements of torque, power, and axial thrust. Turn your vessel's shaft into a live performance sensor.
        </p>
                  <button className="thrustpower-button" onClick={() => onNavigate('contact')}>Book Demo</button>
      </div> */}
      <div className="thrustpower-container">
        <h1 className="thrustpower-title">Shipshape ThrustPower™</h1>
        <p className="thrustpower-subtitle">
           AI-Powered Propulsion Performance Intelligence
        </p>
        <p className="thrustpower-description">
          Gain deeper visibility into propulsion efficiency, vessel performance, and operational trends through advanced analytics and real-time intelligence.

          Shipshape ThrustPower transforms propulsion-related operational data into actionable insights that help operators identify efficiency opportunities, monitor performance trends, reduce fuel waste, and support data-driven decision-making across the fleet.
        </p>
                  <button className="thrustpower-button" onClick={() => onNavigate('contact')}>Book Demo</button>
      </div>
    </section>
{/* 
    // Inside your component, after the first section // */}
    <section className="thrustpower-measures">
    <h2 className="measures-title">What Shipshape ThrustPower™ Measures</h2>
    <div className="measures-cards">
        <div className="measure-card">
        <FaCogs className="measure-icon" />
        <h3>Shaft Torque</h3>
        <p>The rotational force transmitted from engine to propeller</p>
        </div>
        <div className="measure-card">
        <FaTachometerAlt className="measure-icon" />
        <h3>Shaft Power</h3>
        <p>The real propulsion power output, measured in kW</p>
        </div>
        <div className="measure-card">
        <FaShip className="measure-icon" />
        <h3>Axial Thrust</h3>
        <p>The forward-pushing force produced by the propeller</p>
        </div>
    </div>
    <p className="measures-footer">
        These three parameters represent the true performance signature of your propulsion system—<br />
        critical for understanding how much of your fuel is actually going into useful forward motion.
    </p>
    </section>

    {/* // Inside your Upcoming1 component (after section 2) */}
        <section className="torque-matters-section">
        <h2 className="torque-heading">Why Measuring Torque, Power & Thrust Matters</h2>
        <p className="torque-subheading">
            In today’s fuel-cost and emissions-driven environment
        </p>

        <div className="torque-points">
            <div>
            <strong>Hull & Propeller Monitoring</strong>
            <p>A small drop in thrust output may indicate hull or propeller fouling</p>
            </div>
            <div>
            <strong>Efficiency Detection</strong>
            <p>An increase in torque without matching thrust signals inefficiencies or cavitation</p>
            </div>
            <div>
            <strong>Energy Loss Identification</strong>
            <p>A mismatch in shaft power vs speed over ground exposes hidden energy losses</p>
            </div>
        </div>

        <div className="torque-box">
            <h4>Consequences of Unchecked Deviations</h4>
            <ul>
            <li><GiFuelTank className="torque-icon" /> 10% or more fuel cost increase</li>
            <li><FaBalanceScale className="torque-icon" /> CII rating deterioration</li>
            <li><FaTemperatureHigh className="torque-icon" /> Higher EU ETS penalties and off-hire disputes</li>
            <li><FaTimesCircle className="torque-icon" /> Premature dry dock cycles</li>
            </ul>
        </div>
        </section>

        {/* // Add inside Upcoming1 component after previous section */}
            {/* <section className="thrust-features-section">
            <h2 className="thrust-features-heading">Key Features of Shipshape ThrustPower™</h2>

            <div className="thrust-feature-grid">
                <div className="thrust-feature-card">
                <FaMicrochip className="feature-icon" />
                <h4>Real-Time Monitoring</h4>
                <p>High-frequency data delivered via compact, low-intrusion shaftline sensors</p>
                </div>
                <div className="thrust-feature-card">
                <FaExclamationTriangle className="feature-icon" />
                <h4>Early Warning System</h4>
                <p>Detect rising thrust demand or declining power efficiency early</p>
                </div>
                <div className="thrust-feature-card">
                <FaChartLine className="feature-icon" />
                <h4>Performance Optimization</h4>
                <p>Accurately calculate SFOC and improve CII tracking</p>
                </div>
                <div className="thrust-feature-card">
                <FaTools className="feature-icon" />
                <h4>Predictive Maintenance</h4>
                <p>Identify mechanical wear or shaftline misalignment before damage escalates</p>
                </div>
                <div className="thrust-feature-card">
                <FaNetworkWired className="feature-icon" />
                <h4>Shipshape Live™ Integration</h4>
                <p>Full data visibility for shore-based teams through our fleet performance dashboard</p>
                </div>
                <div className="thrust-feature-card">
                <FaBrain className="feature-icon" />
                <h4>Actionable Intelligence</h4>
                <p>Transform monitoring into decision-making assets with trend-based insights</p>
                </div>
            </div>
            </section> */}
            <section className="thrust-features-section">
            <h2 className="thrust-features-heading">Key Features of Shipshape ThrustPower™</h2>

            <div className="thrust-feature-grid">
                <div className="thrust-feature-card">
                <FaMicrochip className="feature-icon" />
                <h4>Real-Time Performance Visibility</h4>
                <p>Monitor operational performance through real-time analytics, trend tracking, and actionable fleet insights.</p>
                </div>
                <div className="thrust-feature-card">
                <FaExclamationTriangle className="feature-icon" />
                <h4>Early Warning System</h4>
                <p>Detect emerging performance inefficiencies, operational anomalies, and potential risks before they impact fleet performance.</p>
                </div>
                <div className="thrust-feature-card">
                <FaChartLine className="feature-icon" />
                <h4>Performance Optimization</h4>
                <p>Accurately calculate SFOC and improve CII tracking</p>
                </div>
                <div className="thrust-feature-card">
                <FaTools className="feature-icon" />
                <h4>Predictive Insights</h4>
                <p>Identify performance trends and operational indicators that may require attention before they affect efficiency or reliability.</p>
                </div>
                <div className="thrust-feature-card">
                <FaNetworkWired className="feature-icon" />
                <h4>Shipshape Live™ Integration</h4>
                <p>Full data visibility for shore-based teams through our fleet performance dashboard</p>
                </div>
                <div className="thrust-feature-card">
                <FaBrain className="feature-icon" />
                <h4>Actionable Intelligence</h4>
                <p>Transform monitoring into decision-making assets with trend-based insights</p>
                </div>
            </div>
            </section>


            {/* <section className="service-package-section">
                <h2 className="service-package-title">Service Package Includes</h2>
                <div className="service-package-box">
                    <div className="service-package-list">
                    <p><FaListAlt className="check-icon" /> Turnkey Installation (Newbuild or Retrofit)</p>
                    <p><FaServer className="check-icon" /> Edge Processing Unit + Shipshape Cloud Sync</p>
                    <p><FaChartLine className="check-icon" /> Custom Dashboard, Alerts & KPIs</p>
                    </div>
                    <div className="service-package-list">
                    <p><FaCog className="check-icon" /> Calibration & Support Services</p>
                    <p><FaExternalLinkAlt className="check-icon" /> Optional API for Integration with Voyage Optimization or PMS</p>
                    </div>
                </div>
                </section> */}
                <section className="service-package-section">
                <h2 className="service-package-title">Service Package Includes</h2>
                <div className="service-package-box">
                    <div className="service-package-list">
                    <p><FaListAlt className="check-icon" /> Platform Configuration & Onboarding</p>
                    <p><FaServer className="check-icon" /> Secure Cloud Analytics Platform</p>
                    <p><FaChartLine className="check-icon" /> Custom Dashboard, Alerts & KPIs</p>
                    </div>
                    <div className="service-package-list">
                    <p><FaCog className="check-icon" /> Customer Success & Technical Support</p>
                    <p><FaExternalLinkAlt className="check-icon" /> Optional API for Integration with Voyage Optimization or PMS</p>
                    </div>
                </div>
                </section>


                <section className="why-thrustpower-section">
      <h2 className="why-thrustpower-title">Why Choose Shipshape ThrustPower™?</h2>
      <div className="why-thrustpower-row">
        <div className="why-thrustpower-col">
          <FaEye className="tick-icon" />
          {/* <div>
            <h4>Patent-Pending, Lightweight Design</h4>
            <p>Easy to retrofit with minimal disruption</p>
          </div> */}
          <div>
            <h4>Advanced Maritime Intelligence</h4>
            <p>Rapid deployment with minimal operational impact</p>
          </div>
        </div>
        <div className="why-thrustpower-col">
          <FaChartLine className="tick-icon" />
          <div>
            <h4>Better Decisions, Sooner</h4>
            <p>Turn performance data into predictive maintenance and fuel-saving actions</p>
          </div>
        </div>
        <div className="why-thrustpower-col">
          <FaCog className="tick-icon" />
          <div>
            <h4>True Shaftline Intelligence</h4>
            <p>Go beyond RPM and fuel flow—know what your propeller is really doing</p>
          </div>
        </div>
        <div className="why-thrustpower-col">
          <FaShieldAlt className="tick-icon" />
          <div>
            <h4>Sustainability Built In</h4>
            <p>Cut CO₂ per NM, optimize CII, and meet ETS obligations with hard data</p>
          </div>
        </div>
      </div>
    </section>

    <section className="optimize-fleet-section">
      <h2>Ready to Optimize Your Fleet Performance?</h2>
      <p>
        Transform your vessel's shaftline into a live performance sensor and
        start making data-driven decisions today.
      </p>
                  <button className="optimize-demo-btn" onClick={() => onNavigate('contact')}>Schedule Demo</button>
    </section>



    <Footer onNavigate={onNavigate} />
    </>
  );
};

export default Upcoming1;
